import RTRBookReaderContent from './RTRBookReaderContent';
export default RTRBookReaderContent;